import {
    GETIBANPROVIDERLIST_SUCCESS,
    GETIBANPROVIDERLIST_FAILED,
    RESET_GETIBANPROVIDERLIST,
    LOADING_GETIBANPROVIDERLIST,
    NETWORK_ERROR_GETIBANPROVIDERLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETIBANPROVIDERLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETIBANPROVIDERLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETIBANPROVIDERLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETIBANPROVIDERLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETIBANPROVIDERLIST:
            return (state = initialState);
        default:
            return state;
    }
};